export const GET_TYPE_ASN_DOCUMENT = 'GET_TYPE_ASN_DOCUMENT'
export const GET_TYPE_ASN_DOCUMENT_EXITO = 'GET_TYPE_ASN_DOCUMENT_EXITO'
export const GET_TYPE_ASN_DOCUMENT_ERRROR = 'GET_TYPE_ASN_DOCUMENT_ERROR'
